const objeto7 = {
    titulo: `Objetos: Definición de getters y setters`,
    problemas: [
        {
            codigo: 1,
            descripcion: `En JavaScript disponemos ahora de la posibilidad de definir setters que son métodos que establecen un valor a una propiedad y getters que son métodos que rescatan un valor.
Para la definición de setters y getters disponemos de las palabras claves set y get.
La definición de propiedades con set y get nos permiten un mejor encapsulamiento de nuestro objeto y definir eventualmente un algoritmo previo al cambio de la propiedad.          
Veremos la sintaxis para definir una propiedad definiendo su setter y getter:
<code>
const dado1 = {
  _valor: 1,
  get valor() {
    return this._valor;
  },
  set valor(v) {
    this._valor = v;
  }
}

dado1.valor = 5
console.log(dado1.valor)  // 5
</code>
En principio parece que no tiene ventaja de definir un setter y un getter, pero en realidad es una buena idea, ya que podemos definir un algoritmo cuando se fija el valor, por ejemplo no dejar asignar un valor incorrecto al dado.`,
            programa: `const dado1 = {
  _valor: 1,
  get valor() {
    return this._valor;
  },
  set valor(v) {
    if (v >= 1 && v <= 6) {
      this._valor = v
    } else {
      console.log('Valor incorrecto')
    }
  }
}

dado1.valor = 7`,
            solucion: "'Valor incorrecto'",
        }, {
            codigo: 2,
            descripcion: `Podemos definir propiedades de solo lectura con getters.`,
            programa: `const persona1 = {
  nombre: 'Juan',
  apellido: 'Perez',
  edad: 20,
  get apellidoNombre() {
    return this.apellido + ' ' + this.nombre
  }
}

console.log(persona1.apellidoNombre)`,
            solucion: "'Perez Juan'",
        }, {
            codigo: 3,
            descripcion: `Como vemos en el ejemplo anterior accedemos a la propiedad apellidoNombre (no se pone paréntesis para hacer referencia a la propiedad apellidoNombre)`,
            programa: `const tablaMultiplicacion = {
  numero: 2,
  get tabla() {
    const t = []
    for (let i = 1; i <= 10; i++) {
      t.push(this.numero * i)
    }
    return t
  }
}

tablaMultiplicacion.numero = 5
console.log(tablaMultiplicacion.tabla)`,
            solucion: "[5, 10, 15, 20, 25, 30, 35, 40, 45, 50]",
        }
    ]
}

export default objeto7;